import { useState, useEffect } from "react";
import { AiFillEyeInvisible, AiFillEye } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import GoogleAuth from "../components/GoogleAuth";
import { Button, TextInput } from "@mantine/core";
import { signInWithEmailAndPassword, getAuth } from "firebase/auth";
import { toast } from "react-toastify";
import { useIntl } from "react-intl";
import { sanitizeInput, validateEmail } from "../utils/helpers";
//import KeysImage from "../assets/images/signinup.png";
//import KeysImage from "../assets/images/signinup_modern.png";
//import KeysImage from "../assets/images/signinup_oldstyle.png";

export default function SignIn() {
  const intl = useIntl();
  const navigate = useNavigate();
  const [errors, setErrors] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [submitEnabled, setSubmitEnabled] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const { email, password } = formData;

  useEffect(() => {
    if (formData.email && formData.password && errors.email === "") {
      setSubmitEnabled(true);
    } else {
      setSubmitEnabled(false);
    }
  }, [formData, errors]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.id]: e.target.value,
    }));
  };

  const onBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { id, value } = e.target;
    let error = "";
    // Apply specific sanitization and validation
    if (id === "email") {
      const sanitizedValue = sanitizeInput(value.trim());
      if (!validateEmail(value)) {
        error = "Please enter a valid email address.";
      } else if (sanitizedValue !== email)
        error = "Please remove all special symbols from the email address.";
    }
    //  else if (id === "password" || id === "confirmPassword") {
    //   sanitizedValue = sanitizeInput(value);
    //   if (!validatePassword(sanitizedValue)) {
    //     error =
    //       "Password must be 8-128 characters, with at least one letter, one number, and one special character.";
    //   }
    // }
    setSubmitEnabled(error === "");
    setErrors((prevState) => ({
      ...prevState,
      [id]: error,
    }));
  };

  const onSubmit = async (e: any) => {
    e.preventDefault();
    try {
      const auth = getAuth();
      const userCredential = await signInWithEmailAndPassword(
        auth,
        sanitizeInput(email),
        password
      );
      if (userCredential.user) {
        navigate("/");
      }
    } catch (error) {
      toast.error("Bad user credentials");
    }
  };

  return (
    <section className="signin-section">
      <div className="signin-form-container">
        <h1 className="signin-heading">
          {intl.formatMessage({ id: "signin.signIn" })}
        </h1>
        <form style={{}} onSubmit={onSubmit}>
          <TextInput
            type="email"
            id="email"
            value={email}
            onChange={onChange}
            onBlur={onBlur}
            placeholder={intl.formatMessage({ id: "signup.email" })}
            className="signin-input"
            maxLength={100}
            error={errors.email}
          />
          <div className="password-container">
            <TextInput
              type={showPassword ? "text" : "password"}
              id="password"
              value={password}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={intl.formatMessage({ id: "signup.password" })}
              className="signin-input"
              maxLength={100}
              //error={errors.password}
            />
            {!showPassword ? (
              <AiFillEyeInvisible
                className="password-toggle"
                onClick={() => setShowPassword((prevState) => !prevState)}
              />
            ) : (
              <AiFillEye
                className="password-toggle"
                onClick={() => setShowPassword((prevState) => !prevState)}
              />
            )}
          </div>
          <div className="signin-links">
            <p className="signup-link">
              {intl.formatMessage({ id: "signin.dontHaveAccount" })}
              <Link to="/sign-up" className="signin-link-register">
                {intl.formatMessage({ id: "signin.register" })}
              </Link>
            </p>
            <p>
              <Link to="/forgot-password" className="signin-link-forgot">
                {intl.formatMessage({ id: "signin.forgotPassword" })}
              </Link>
            </p>
          </div>
          <Button
            disabled={!submitEnabled}
            fullWidth
            className="signin-button"
            type="submit"
          >
            {intl.formatMessage({ id: "signin.signIn" })}
          </Button>
          <div className="signin-divider">
            <p className="signin-divider-text">
              {intl.formatMessage({ id: "signin.or" })}
            </p>
          </div>
          <GoogleAuth disabled={false} />
        </form>
      </div>
    </section>
  );
}
